import { render, staticRenderFns } from "./widget_artificial_intelligence.vue?vue&type=template&id=0d1c392c&scoped=true&"
import script from "./widget_artificial_intelligence.vue?vue&type=script&lang=js&"
export * from "./widget_artificial_intelligence.vue?vue&type=script&lang=js&"
import style0 from "./widget_artificial_intelligence.vue?vue&type=style&index=0&id=0d1c392c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c392c",
  null
  
)

export default component.exports